




































































import Vue from "vue";
import { log } from 'console';
import { mapGetters, mapState } from "vuex";
import { sections } from "./create-form";
import Share from "@/components/Share.vue";
import RenderSVG from "@/components/RenderSVG.vue";

export default Vue.extend({
  name: "Create",
  components: { Share, RenderSVG },
  data: function() {
    return {
      loading: true,
      form: {
        section: 0,
        valid: true,
      },
      values: {} as any,
      defaults: {
        seed: Date.now(),
        shapes: 11,
        x: 200,
        y: 200,
        xSeg: 2,
        ySeg: 2,
        width: [200, 300],
        height: [200, 300],
        hatching: 0,
        mirrorAdv: false,
        mirrorA: true,
        mirrorB: true,
        mirrorC: true,
        mirrorPos1: 600,
        mirrorPos2: 1200,
        mirrorPos3: 2400,
        scale: 100,
        hue: Date.now() % 360,
        saturation: 80,
        lightness: [30,70],
        shades: 3,
        scheme: 0,
        animate: false,
        animation: 9,
      },
      sections: sections,
    };
  },
  computed: {
    paramsSet: function() {
      return Object.keys(this.$route.query).length > 0
    },
    active: function() {
      return (this as any).sections.map((s: any) => {
        s.options.filter((o: any) => !o.hide || (this as any).values[o.hide]);
        return s;
      });
    },
    ...mapState({
        animationTitles: 'animationTitles',
        schemeTitles: 'schemeTitles',
    }),
    ...mapGetters(["currentAccount", "wrongNetwork"]),
  },
  mounted: async function() {
    const t = this as any;
    await this.$store.dispatch("initialize");
    if (!(this as any).wrongNetwork) {
      t.loadFormDefaults();
      if (t.paramsSet) t.loadParams();
      else t.updateParams();
      t.loadToken();
    }
  },
  methods: {
    randomizeSection: function(section: number | string) {
      const t = this as any;
      t.randomize(section);
      t.loadToken()
        .then((art: any) => {
          if (art) t.updateParams();
        })
        .catch((err: any) => {
          console.error("Invalid Box Options - Call Reverted: ", err)
          console.log("Retrying Randomize...")
          t.randomizeSection(section)
        });
    },
    randomize: function(section: number | string) {
      const t = this as any;
      const randomSettings: any = {};
      for (const s of (section === "all") ? t.sections : [t.sections[section]]) {
        if (s.rand) {
          for (const o of s.options) {
            if (o.rand !== false && !t.values[o.hide] && t.values[o.show] !== false) {
              const range = o.rand ? o.rand : o.range;
              switch (o.type) {
                case "switch":
                  randomSettings[o.key] = Math.random() > (o.randWeight ? o.randWeight : 0.5);
                  break;
                case "range-slider":
                  randomSettings[o.key] = [range, range]
                    .map((r) => t.between(r))
                    .sort();
                  break;
                default:
                  randomSettings[o.key] = t.between(range);
                  break;
              }
            }
          }
        }
      }
      Object.assign(t.values, randomSettings);
    },
    between: function(range: any) {
      return Math.floor(
        Math.random() * (range.max - range.min + 1) + range.min
      );
    },
    formatHash(account: string) {
      return "0x" + account.slice(2, 6) + "...." + account.slice(-4);
    },
    undo() {
      const t = this as any;
      history.back()
      t.loadParams();
      t.loadToken();
    },
    redo() {
      const t = this as any;
      history.forward()
      t.loadParams();
      t.loadToken();
    },
    changed: async function() {
      const t = this as any;
      t.updateParams();
      t.loadToken();
    },
    reset() {
      const t = this as any;
      t.loadFormDefaults();
      t.changed();
    },
    loadFormDefaults: function() {
      const t = this as any;
      // set values to default
      Object.assign(t.values, t.defaults);
    },
    loadParams() {
      const t = this as any;
      // overwrite with any url query params
      const query = t.parseQuery(t.$route.query);
      Object.assign(t.values, query);
    },
    updateParams() {
      const t = this as any;
      if (t.$route.query === {}) this.$router.replace({ query: t.values });
      else this.$router.push({ query: t.values });
    },
    parseQuery(query: any) {
      const out: any = {};
      // check true, false, array, string, number
      for (const [i,q] of Object.entries(query)) {
        out[i] = q === "true" ? true : 
          ( q === "false" ? false : 
            ( Array.isArray(q) ? (q as any).map((v: any) => parseInt(v)) :
              ( ( i === "seed" || isNaN(parseInt(q as any)) ) ? q : parseInt(q as any) ) ) );
      }
      return out;
    },
    loadToken: function() {
      return new Promise((resolve, reject) => {
        const t = this as any;
        if (!t.form.valid) reject("Invalid Form Values");
        t.loading = true;
        // update the local renderer
      })
    },
  },
});
